import { Flex, HStack, Meter, Text, type BoxProps } from '@talos/kyoko';
import Big from 'big.js';

export const MakerTakerChart = ({ maker = 0, taker = 0, ...props }: { maker?: number; taker?: number } & BoxProps) => {
  const makerPct = Big(maker).times(100).toFixed(2);
  const takerPct = Big(taker).times(100).toFixed(2);

  return (
    <Flex flexDirection="column" gap="spacing4" {...props}>
      <HStack justifyContent="space-between">
        <Text color="colorTextSubtle" size="fontSizeSmall">
          Maker <Text color="colors.blue.lighten">{makerPct}%</Text>
        </Text>
        <Text color="colorTextSubtle" size="fontSizeSmall">
          Taker <Text color="colors.gray.090">{takerPct}%</Text>
        </Text>
      </HStack>
      <Meter
        value={maker}
        showLabel={false}
        color="colors.blue.lighten"
        backgroundColor={maker === 0 && taker === 0 ? undefined : 'colors.gray.090'}
      />
    </Flex>
  );
};
